import { Stack } from '@mui/material'
import { ScheduleTypeEnum } from '@ulysses-inc/harami_api_client'
import { FormikProps } from 'formik'
import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RootState } from 'src/state/store'
import ActivenessRow from './ActivenessRow'
import { ScheduleForm } from './EditSchedule'
import FrequencyRow from './FrequencyRow'
import NotifiedGroupsRow from './NotifiedGroupsRow'
import PeriodPerDayRow from './PeriodPerDayRow'
import PeriodRow from './PeriodRow'
import PlaceRow from './PlaceRow'
import ScheduleNameRow from './ScheduleNameRow'
import TemplateRow from './TemplateRow'
import TypeRow from './TypeRow'

const EditScheduleContent: React.FC<{
  formProps: FormikProps<ScheduleForm>
}> = ({ formProps }) => {
  const scheduleId = useParams<{ scheduleId?: string }>().scheduleId ?? ''
  const placeNodes = useSelector(
    (state: RootState) => state.placesState.placeGroups.nodes,
  )
  const templates = useSelector(
    (state: RootState) => state.schedulesState.schedulesTemplates.templates,
  )

  const {
    values: { type },
  } = formProps

  return (
    <Stack
      spacing={2}
      py={4}
      px={3}
      sx={{ maxWidth: 900, width: '100%', mx: 'auto' }}
    >
      <ScheduleNameRow {...formProps} scheduleId={scheduleId} />
      <ActivenessRow {...formProps} />
      <TemplateRow {...formProps} templates={templates} />
      <PlaceRow {...formProps} placeNodes={placeNodes} />
      <TypeRow {...formProps} />
      <FrequencyRow {...formProps} />
      <PeriodRow {...formProps} />
      {type === ScheduleTypeEnum.Date && <PeriodPerDayRow {...formProps} />}
      <NotifiedGroupsRow {...formProps} />
    </Stack>
  )
}

export default EditScheduleContent
